// extracted by mini-css-extract-plugin
export default {"movable":"ModuleSliderStyles_movable__uPn-5"};